module.exports = __webpack_public_path__ + "img/cross.fd36581e.svg";